/* global SERVER_URL */
import React from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-fetch';
import { Slider, Pagination } from 'react-slick';
import chunk from 'lodash/chunk';
import times from 'lodash/times';
import isEmpty from 'lodash/isEmpty';
import stubArray from 'lodash/stubArray';
import { trackWindowScroll } from 'react-lazy-load-image-component';

import SnapshotPage from '../SnapshotPage';
import { formatNumber, checkHttpStatus, parseJSON } from '../../../utils';
import './styles.scss';
import AllMemberSnapshots from './AllMemberSnapshots';

class MemberSnapshotsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = { navigationEnabled: false, snapshotGroups: [], currentPage: 1, stateToggle: false, showAll: false };
    this.paginationRender = this.paginationRender.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.afterChangeHandler = this.afterChangeHandler.bind(this);
    this.snapshotPages = new Map();
  }

  afterChangeHandler(pageIndex) {
    const { snapshotGroups } = this.state;
    if (!snapshotGroups[pageIndex] || snapshotGroups[pageIndex].length === 0) {
      this.fetchSnapshotResults(pageIndex + 1);
    }
    window.dispatchEvent(new CustomEvent('checkImageLazyload'));
  }

  shouldComponentUpdate(nextProps, nextState) {
    for (const property in nextProps) {
      if (nextProps[property] !== this.props[property]) {
        return true;
      }
    }

    for (const property in nextState) {
      if (nextState[property] !== this.state[property]) {
        if (property !== 'currentPage') return true;
      }
    }
    return false;
  }

  componentWillReceiveProps(nextProps) {
    const { snapshots, count, snapshotsPerPage } = nextProps;
    const totalPages = Math.ceil(count / snapshotsPerPage);
    if (isEmpty(snapshots)) return;
    const chunkedSnapshots = times(totalPages, stubArray);
    chunk(snapshots, snapshotsPerPage).forEach((snapshots, index) => chunkedSnapshots[index] = snapshots);
    if (totalPages > 1) {
      this.setState({ navigationEnabled: true, snapshotGroups: chunkedSnapshots });
    } else {
      this.setState({ navigationEnabled: false, snapshotGroups: chunkedSnapshots });
    }
  }

  componentDidMount() {
    const { snapshots, count, snapshotsPerPage } = this.props;
    const totalPages = Math.ceil(count / 16);
    if (isEmpty(snapshots)) return;
    const chunkedSnapshots = times(totalPages, stubArray);
    chunk(snapshots, snapshotsPerPage).forEach((snapshots, index) => {
      chunkedSnapshots[index] = snapshots;
    });
    if (totalPages > 1) {
      this.setState({ navigationEnabled: true, snapshotGroups: chunkedSnapshots });
    } else {
      this.setState({ navigationEnabled: false, snapshotGroups: chunkedSnapshots });
    }
  }

  fetchSnapshotResults(page) {
    fetch(`${SERVER_URL}/get_user_snapshots.json?username=${encodeURIComponent(this.props.username)}&page=${page}`, {
      headers: {
        Accept: 'application/json, text/javascript, */*; q=0.01',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const { snapshotGroups } = this.state;
        snapshotGroups[page - 1] = response.data.snapshots;
        this.setState({ snapshotGroups, stateToggle: !this.state.stateToggle });
      });
  }

  next() {
    if (this.state.navigationEnabled) {
      this.memberSlider.slickNext();
    }
    document.dispatchEvent(new CustomEvent('resize'));
  }

  previous() {
    if (this.state.navigationEnabled) {
      this.memberSlider.slickPrev();
    }
    document.dispatchEvent(new CustomEvent('resize'));
  }

  paginationRender(currentPage, totalPages) {
    return (
      <span ref="slideNumber" type="text" className="pagination-numbers">{currentPage} / {totalPages} </span>
    );
  }

  render() {
    const { slickSettings, count, scrollPosition, username } = this.props;
    const { navigationEnabled, snapshotGroups, showAll } = this.state;
    const disabled = (navigationEnabled) ? '' : ' disabled';
    const slides = (snapshotGroups.length > 0) ? snapshotGroups : null;
    slickSettings.afterChange = this.afterChangeHandler;

    const renderContent = () => {
      return showAll ? ( <AllMemberSnapshots username={username} scrollPosition={scrollPosition} />) : (
        <Slider
          {...slickSettings}
          ref={(c) => { this.memberSlider = c; }}
          className="member-snapshots-slider"
          paginationRender={this.paginationRender}
        >
          {
            slides.map((slideSnapshots, index) => {
              return slideSnapshots.length > 0 ?
              (
                <SnapshotPage
                  key={index}
                  snapshots={snapshotGroups[index]}
                  className="slick-slide"
                  ref={c => this.snapshotPages.set(index, c)}
                  scrollPosition={scrollPosition}
                />
              ) : (
                <SnapshotPage
                  key={index}
                  ref={c => this.snapshotPages.set(index, c)}
                  scrollPosition={scrollPosition}
                />
              );
            })
          }
        </Slider>
      );
    }
    return (
      <div className="member-slider-group">
        <div className="row">
          <div className="section-header col-12 bg-fff-80 border-grey">
            <div className="row no-gutters">
              <div className="title-link border-r-grey title-block">Snapshots Taken</div>
              <div className="title-block col">{ formatNumber(count) } Images</div>

              {this.state.showAll ? (
                <div className="col m-0 row align-items-center">
                  <div className="col m-0 row text-right">
                    <div className="col m-0 py-0 title-block"><button className="btn btn-sm" onClick={() => { this.setState({ showAll: !this.state.showAll }) }}>Show Pages</button></div>
                  </div>
                </div>
              ) : (
                <div className="col m-0 row align-items-center">
                  <div className="col m-0 row text-right">
                    <div className="col m-0 py-0 title-block"><button className="btn btn-sm" onClick={() => { this.setState({ showAll: !this.state.showAll }) }}>View All</button></div>
                    <div className="align-self-center col-auto px-0"><Pagination name="member-snapshots-pagination" /></div>
                  </div>
                  <div className={"title-block border-l-grey pagination-button" + disabled} onClick={this.previous}><i className="icon-ButtonArrowLeft"></i></div>
                  <div className={"title-block border-l-grey pagination-button" + disabled} onClick={this.next}><i className="icon-ButtonArrowRight"></i></div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          {
            slides && renderContent()}
        </div>
      </div>
    );
  }
}

MemberSnapshotsView.propTypes = {
  snapshots: PropTypes.array,
  count: PropTypes.number,
  snapshotsPerPage: PropTypes.number,
  username: PropTypes.string,
};

MemberSnapshotsView.defaultProps = {
  snapshots: [],
  count: 0,
  snapshotsPerPage: 16,
  username: '',
  slickSettings: {
    infinite: true,
    arrows: false,
    adaptiveHeight: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    paginationName: 'member-snapshots-pagination',
  },
};

export default trackWindowScroll(MemberSnapshotsView);
